import React, { useContext, useEffect } from 'react';
import * as R from 'ramda';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { func } from 'prop-types';

// Components
import CustomerAffiliateSelect from '../components/customer-affiliate-select/CustomerAffiliateSelect.connector';
import NavigationButtons from '../components/navigation-buttons/NavigationButtons';
import SubscriptionHeader from '../components/subscription-header/SubscriptionHeader';
import UsageChart from '../components/usage-chart/UsageChart';

// Context
import { SubscriptionsContext } from '../SubscriptionsContext';

// Styles
import * as styles from './CustomerSelection.styles';

// Utils
import formatGraphData from '../utils/graphData';

const SubscriptionCustomerSelection = ({ setGlobalCustomersLoading }) => {
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });
  const navigate = useNavigate();
  const {
    currentStep,
    data: { globalCustomer, globalAffiliatesVolumes },
    setCurrentStep,
  } = useContext(SubscriptionsContext);

  const continueDisabled = !globalCustomer?.id || R.isEmpty(globalAffiliatesVolumes);

  useEffect(() => {
    if (currentStep !== 1) setCurrentStep(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return (
    <Box sx={styles.scroll}>
      <SubscriptionHeader
        disabled={continueDisabled}
        handleLeftButtonClick={() => navigate('..')}
        handleRightButtonClick={() => {
          navigate(`../step2`);
          setGlobalCustomersLoading();
        }}
        leftLabel="Back"
        rightLabel="Next"
        title="Included Affiliates"
      />
      <Box sx={styles.layout}>
        {mdUp ? (
          <Box
            borderRadius="4px"
            boxShadow={5}
            display="flex"
            flexDirection="row"
            sx={styles.content}
          >
            <Box display="flex" flexDirection="column" minHeight={184} p={4} width={406}>
              <CustomerAffiliateSelect />
            </Box>
            {globalAffiliatesVolumes && !R.isEmpty(globalAffiliatesVolumes) && (
              <Box alignItems="center" display="flex" flexDirection="column" px={3} py={4}>
                <Typography
                  // Left padding to center align text over graph
                  sx={{ color: 'text.primary', pl: 4 }}
                  variant="subtitle1"
                >
                  Usage Data
                </Typography>
                <UsageChart
                  chartHeight={320}
                  chartWidth={460}
                  usageData={formatGraphData(globalAffiliatesVolumes)}
                />
              </Box>
            )}
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" maxWidth={406}>
            <CustomerAffiliateSelect usageData={formatGraphData(globalAffiliatesVolumes)} />
          </Box>
        )}
      </Box>

      {!mdUp && (
        <NavigationButtons
          disabled={continueDisabled}
          handleLeftButtonClick={() => navigate('../')}
          handleRightButtonClick={() => {
            navigate(`../step2`);
            setGlobalCustomersLoading();
          }}
          leftLabel="Back"
          rightLabel="Next"
        />
      )}
    </Box>
  );
};

SubscriptionCustomerSelection.propTypes = {
  setGlobalCustomersLoading: func.isRequired,
};

export default SubscriptionCustomerSelection;
